const updateLanguage = (language) => {
    sessionStorage.setItem("LANGUAGE", language);
    window.history.go(0);
}

export default updateLanguage;